import useAppSelector from '@/features/app/hooks/useAppSelector';
import * as Sentry from '@sentry/react';
import { useEffect, useRef } from 'react';

export default function useReportBugButton() {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    if (!buttonRef.current) return;

    const feedback = Sentry.getFeedback();
    if (!feedback) return;
    feedback?.attachTo(buttonRef.current);
    return () => {
      feedback?.remove();
    };
  }, [user]);

  return buttonRef;
}
